module.exports = __webpack_public_path__ + "static/img/logo-volofin.68873d18.svg";